import { render, staticRenderFns } from "./p07.vue?vue&type=template&id=786b6afb&scoped=true&"
import script from "./p07.vue?vue&type=script&lang=js&"
export * from "./p07.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786b6afb",
  null
  
)

export default component.exports